import React, { FC } from "react";
import Apple from "@/public/icons/appleStoreDownload.svg";
import Google from "@/public/icons/googleStoreDownload.svg";
import Button from "@/components/Buttons/Primary/Button";
import styles from "@/components/Buttons/Primary/styles.module.css";
import { useTranslations } from "next-intl";
import ParamsLink from "@/components/pages/Landings/ParamsLink";
import { Link } from "@/navigation";

const StartEarning: FC<{
  title: string;
  subtitle: string;
  buttonLabel: string;
}> = ({ title, subtitle, buttonLabel }) => {
  const t = useTranslations();

  return (
    <div className="pb-[96px] px-[20px]">
      <div className="relative mx-auto max-w-[940px] w-full p-[32px] bg-primary rounded-[16px] overflow-hidden">
        <div
          className="hidden md:block absolute w-full h-full top-0 left-0"
          style={{
            backgroundImage: 'url("/landing/startEarningConfetti.svg")',
            backgroundSize: "cover",
            backgroundPosition: "center top",
            backgroundRepeat: "no-repeat",
          }}
        />
        <div
          className="hidden md:block absolute w-[27%] h-full bottom-0 left-[2%]"
          style={{
            backgroundImage: 'url("/landing/startEarningCardsLeft.svg")',
            backgroundSize: "contain",
            backgroundPosition: "left 10% bottom 10%",
            backgroundRepeat: "no-repeat",
          }}
        />
        <div
          className="hidden md:block absolute w-[27%] h-full bottom-0 right-[2%]"
          style={{
            backgroundImage: 'url("/landing/startEarningCardsRight.svg")',
            backgroundSize: "contain",
            backgroundPosition: "right 10% bottom 10%",
            backgroundRepeat: "no-repeat",
          }}
        />
        <div className="relative z-10 flex flex-col items-center justify-center gap-[24px]">
          <h2 className="text-[32px] leading-[38px] text-white font-bold text-center">
            {title}
          </h2>
          <p className="text-[18px] max-w-[550px] w-full mx-auto text-center text-white leading-[28px]">
            {subtitle}
          </p>
          <ParamsLink href="/register">
            <Button
              className="bg-white text-primary min-w-[200px] hover:!bg-black-200"
              label={buttonLabel}
              isShineHover
            />
          </ParamsLink>
          <p className="text-[14px] font-semibold text-center text-white">
            {t("Landing.alsoAvailable")}
          </p>
          <div className="flex items-center justify-between gap-[10px]">
            <Link
              className={styles.shine}
              target="_blank"
              aria-label="Play market"
              href="https://play.google.com/store/apps/details?id=de.rewards.app"
            >
              <Google />
            </Link>
            <Link
              className={styles.shine}
              target="_blank"
              aria-label="Appstore"
              href="https://apps.apple.com/de/app/rewards-de-geld-verdienen/id1673567402"
            >
              <Apple />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StartEarning;
